import { ca } from '@cian/analytics';

import { TBubbleBody } from '../../types/messageBubble';

export const trackBubbleShow = (chatId: string, bubbleType: string) => {
  try {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Chat',
      action: 'Show_sopr',
      label: 'Bubble',
      page: {
        extra: {
          chat_id: chatId,
          bubble_type: bubbleType,
        },
      },
    });
  } catch (error) {
    console.debug('trackBubbleShow', error);
  }
};

/**
 * Содержимое баббла «Инфо о клиенте»: тип баббла на клиенте неизвестен, поэтому отдаём в аналитику
 * всё, что показали пользователю, — сам тип, заголовок, тело баббла и текст кнопки, если она есть.
 */
interface ISubsChatRichBubbleShowParams {
  analyticsBubbleType: string;
  title?: string;
  body: TBubbleBody[] | null;
  buttonTitle?: string;
}

/** Показ баббла с информацией о клиенте (мобвеб-аналог вкладки «О клиенте» в карточке собеседника). */
export const trackSubsChatRichBubbleShow = (params: ISubsChatRichBubbleShowParams): void => {
  const { analyticsBubbleType, title, body, buttonTitle } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Show',
    label: 'SubsChatRichBubble',
    page: {
      extra: {
        analyticsBubbleType,
        title,
        body,
        button_title: buttonTitle,
      },
    },
  });
};
